import { render, staticRenderFns } from "./Tarh.vue?vue&type=template&id=6856e357&scoped=true"
import script from "./Tarh.vue?vue&type=script&lang=js"
export * from "./Tarh.vue?vue&type=script&lang=js"
import style0 from "./Tarh.vue?vue&type=style&index=0&id=6856e357&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6856e357",
  null
  
)

export default component.exports